// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"675":"7fc60dbc63e4fbbc","707":"4c5fd3eacc8d18a1","912":"df5cfec9b9fb9194"}[chunkId] + ".css";
};